import {Injectable, Injector, runInInjectionContext} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Router} from '@angular/router';
import {
  Auth,
  browserLocalPersistence,
  setPersistence,
  signInWithEmailAndPassword,
  signOut,
  UserCredential
} from '@angular/fire/auth';
import {AuthInfo} from './auth-info';


@Injectable()
export class AuthService {

  static UNKNOWN_USER = new AuthInfo(null);

  authInfo$: BehaviorSubject<AuthInfo> = new BehaviorSubject<AuthInfo>(AuthService.UNKNOWN_USER);

  constructor(public auth: Auth, private router: Router, private injector: Injector) {
    setPersistence(auth, browserLocalPersistence);
  }

  login(email, password): Promise<void | UserCredential> {
    return runInInjectionContext(this.injector, () =>
      setPersistence(this.auth, browserLocalPersistence).then(() =>
        signInWithEmailAndPassword(this.auth, email, password)
      ).catch(err => {
        console.error(err);
      })
    );
  }

  logout(): void {
    runInInjectionContext(this.injector, () => signOut(this.auth));
    this.authInfo$.next(AuthService.UNKNOWN_USER);
    this.router.navigate(['/lists']);
  }

}
